<template>
  <!-- style="min-height: 380px" -->
  <a-card hoverable :key="country.cca2">
    <h4 slot="title">{{ country.name.common }}</h4>
    <div slot="cover" style="box-shadow: 0 0 1px rgba(0, 0, 0, 0.4)">
      <img
        v-if="country.flag"
        alt="flag"
        :src="country.flag"
        style="max-width: 100%"
      />
    </div>
    <span class="flag" :class="country.cca2 | createCssFlagClass"></span>
    <slot></slot>
  </a-card>
</template>

<script>
export default {
  props: ['country'],
  filters: {
    createCssFlagClass(value) {
      if (!value) {
        return '';
      }

      return `flag-${value.toLowerCase()}`;
    },
  },
};
</script>

<style lang="scss" scoped></style>
